import { Texture } from '@luma.gl/core';
import { ShaderModule } from '@luma.gl/shadertools';

export const positionTextureModuleName = 'positionTextureModule';
export const positionTextureModule: ShaderModule<{ positionTexture: Texture | undefined }> = {
    name: positionTextureModuleName,
    inject: {
        'vs:#decl': `
            in uint instanceId;
            uniform sampler2D positionTexture;
        `,
        'vs:#main-start': `
            uint x = instanceId % 320u;
            uint y = instanceId / 320u;
            vec3 instancePositions = vec3(texelFetch(positionTexture, ivec2(x, y), 0).xy, 0.0);
            vec3 instancePositions64Low = vec3(0.0);
        `
    },
    getUniforms: (props) => {
        if (!props.positionTexture) {
            return {};
        }
        return {
            positionTexture: props.positionTexture
        };
    }
} as const;


export const positionTextureLineModuleName = 'positionTextureLineModule';
export const positionTextureLineModule: ShaderModule<{ positionTexture: Texture | undefined }> = {
    name: positionTextureLineModuleName,
    inject: {
        'vs:#decl': `
            in uint instanceId;
            uniform sampler2D positionTexture;
        `,
        'vs:#main-start': `
            uint x = instanceId % 320u;
            uint y = instanceId / 320u;
            vec3 instanceSourcePositions = vec3(texelFetch(positionTexture, ivec2(x, y), 0).xy, 0.0);
            vec3 instanceSourcePositions64Low = vec3(0.0);
        `
    },
    getUniforms: (props) => {
        if (!props.positionTexture) {
            return {};
        }
        return {
            positionTexture: props.positionTexture
        };
    }
} as const;



export const positionTextureProjectedLineModuleName = 'positionTextureProjectedLineModule';
export const positionTextureProjectedLineModule: ShaderModule<{ positionTexture: Texture | undefined }> = {
    name: positionTextureProjectedLineModuleName,
    inject: {
        'vs:#decl': `
            in uint instanceId;
            uniform sampler2D positionTexture;
        `,
        'vs:#main-start': `
            uint x = instanceId % 320u;
            uint y = instanceId / 320u;
            vec3 instanceSourcePositions = vec3(texelFetch(positionTexture, ivec2(x, y), 0).xy, 0);
            vec3 instanceSourcePositions64Low = vec3(0.0);

            vec3 instanceTargetPositions = vec3(texelFetch(positionTexture, ivec2(x, y), 0).zw, 0);
            vec3 instanceTargetPositions64Low = vec3(0.0);
        `
    },
    getUniforms: (props) => {
        if (!props.positionTexture) {
            return {};
        }
        return {
            positionTexture: props.positionTexture
        };
    }
} as const;

